import { CreateOrderSheetOrderItemInput } from '../../graphql/select-option_types.2';

/**
 * 퍼널 정보를 추가합니다
 * @param orderItem - 주문 아이템
 * @param funnelType - 퍼널 타입
 * @returns 퍼널 정보를 추가한 주문 아이템
 */
export const applyFunnelInfo = (
  orderItem: CreateOrderSheetOrderItemInput,
  funnelType: string,
): CreateOrderSheetOrderItemInput => {
  if (funnelType) {
    orderItem.funnel_info = { type: funnelType };
  }
  return orderItem;
};
